// Components, Layouts, Pages
import {
  EmployeePageStaff,
  JobPageStaff,
  FormContactPageStaff,
  TaskPageStaff,
  InvoicePageStaff,
} from '~/pages/staff';
import {
  SchedulePageTemplate,
  ContactDetailPage,
  CustomerDetailTemplate,
  JobDetailTemplate,
  FormCustomerTemplate,
  CustomerPageTemplate,
  FormEmployeeTemplate,
  EmployeeDetailTemplate,
  FormTaskTemplate,
  CategoryPageTemplate,
  ServicePageTemplate,
  MaterialPageTemplate,
  FormServiceTemplate,
  FormMaterialTemplate,
  FormPriceBookTemplate,
  ServiceDetailTemplate,
  TaskDetailPageTemplate,
  MaterialDetailTemplate,
  PriceBookDetailTemplate,
  MessagePageTemplate,
  TimeClockPageTemplate,
  TimeClockDetailTemplate,
  DashboardPageTemplate,
  EstimatePageTemplate,
  FormEstimateTemplate,
  MarketingPageTemplate,
  CampaignPageTemplate,
  FormCampaignTemplate,
  CampaignDetailTemplate,
  EstimateDetailTemplate,
  FormJobTemplate,
  ProfileTemplate,
  InvoiceDetailTemplate,
  ReportPageTemplate,
  SubReviewPageTemplate,
  GmailPageTemplate,
  ReportTechnicianPageTemplate,
  ReportSaleByCityPageTemplate,
  ReportServiceVolumePageTemplate,
  ReportPerCallAveragePageTemplate,
  ReportPoPerPayPeriodPageTemplate,
} from '~/pages/template';
// Others
import { MenuNameEnum } from '~/utils/enum/common';
import { IRouteModel } from '~/utils/interface/base';
// Styles, images, icons
import { icons } from '~/assets';

export const staffRoute = {
  base: '/staff',
  employees: '/employees',
  customers: '/customers',
  customerDetail: '/customers/:id',
  schedule: '/schedule',
  crm: '/crm',
  inventory: '/inventory',
  services: '/services',
  materials: '/materials',
  estimateTemplate: '/estimateTemplate',
  priceBooks: '/price-books',
  contacts: '/contacts',
  pipeline: '/pipeline',
  jobs: '/jobs',
  tasks: '/tasks',
  estimate: '/estimate',
  timeClock: '/time-clocks',
  payroll: '/payroll',
  marketing: '/marketing',
  campaigns: '/campaigns',
  reports: '/reports',
  technicianReport: '/technician',
  saleByCityReport: '/sale-by-city',
  serviceVolumeReport: '/service-volume',
  perCallAverageReport: '/per-call-average',
  poPerPayPeriodReport: '/po-per-pay-period',
  settings: '/settings',
  integration: '/integration',
  message: '/message',
  profile: '/profile',
  invoice: '/invoice',
  review: '/review',
  gmail: '/gmail',

  // Common
  commonCreate: '/create',
  commonEdit: '/edit',
  commonDetail: '/:id',
};

export const privateStaffRoutes: IRouteModel[] = [
  {
    index: true,
    path: `${staffRoute.base}`,
    component: DashboardPageTemplate,
    name: MenuNameEnum.DASHBOARD,
    icon: icons.menuIconDashboardInactive,
    activeIcon: icons.menuIconDashboardActive,
  },
  {
    path: `${staffRoute.base}${staffRoute.employees}`,
    component: EmployeePageStaff,
    name: MenuNameEnum.EMPLOYEES,
    icon: icons.menuIconEmployeesInactive,
    activeIcon: icons.menuIconEmployeesActive,
  },
  {
    path: `${staffRoute.base}${staffRoute.employees}${staffRoute.commonCreate}`,
    component: FormEmployeeTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.employees}${staffRoute.commonDetail}${staffRoute.commonEdit}`,
    component: FormEmployeeTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.employees}${staffRoute.commonDetail}`,
    component: EmployeeDetailTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.customers}`,
    component: CustomerPageTemplate,
    name: MenuNameEnum.CUSTOMERS,
    icon: icons.menuIconCustomersInactive,
    activeIcon: icons.menuIconCustomersActive,
  },
  {
    path: `${staffRoute.base}${staffRoute.customers}${staffRoute.commonCreate}`,
    component: FormCustomerTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.customers}${staffRoute.commonDetail}${staffRoute.commonEdit}`,
    component: FormCustomerTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.customers}${staffRoute.commonDetail}`,
    name: MenuNameEnum.CUSTOMER_DETAIL,
    component: CustomerDetailTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.schedule}`,
    component: SchedulePageTemplate,
    name: MenuNameEnum.SCHEDULE,
    icon: icons.menuIconScheduleInactive,
    activeIcon: icons.menuIconScheduleActive,
  },
  // {
  //   path: `${staffRoute.base}${staffRoute.crm}`,
  //   component: CrmPageStaff,
  //   name: MenuNameEnum.CRM,
  //   icon: icons.menuIconCRMInactive,
  //   activeIcon: icons.menuIconCRMActive,
  //   children: [
  //     {
  //       path: `${staffRoute.base}${staffRoute.crm}${staffRoute.contacts}`,
  //       component: ContactPageStaff,
  //       name: MenuNameEnum.CONTACTS,
  //     },
  //     {
  //       path: `${staffRoute.base}${staffRoute.crm}${staffRoute.pipeline}`,
  //       component: PipelineTemplate,
  //       name: MenuNameEnum.PIPELINE,
  //     },
  //   ],
  // },
  {
    path: `${staffRoute.base}${staffRoute.crm}${staffRoute.contacts}${staffRoute.commonCreate}`,
    component: FormContactPageStaff,
  },
  {
    path: `${staffRoute.base}${staffRoute.crm}${staffRoute.contacts}${staffRoute.commonDetail}`,
    name: MenuNameEnum.CONTACT_DETAIL,
    component: ContactDetailPage,
  },
  {
    path: `${staffRoute.base}${staffRoute.crm}${staffRoute.contacts}${staffRoute.commonDetail}${staffRoute.commonEdit}`,
    component: FormContactPageStaff,
  },
  {
    path: `${staffRoute.base}${staffRoute.inventory}`,
    component: CategoryPageTemplate,
    name: MenuNameEnum.INVENTORY,
    icon: icons.menuIconCategoryInactive,
    activeIcon: icons.menuIconCategoryActive,
    children: [
      {
        path: `${staffRoute.base}${staffRoute.inventory}${staffRoute.services}`,
        component: ServicePageTemplate,
        name: MenuNameEnum.SERVICES,
      },
      {
        path: `${staffRoute.base}${staffRoute.inventory}${staffRoute.materials}`,
        component: MaterialPageTemplate,
        name: MenuNameEnum.MATERIALS,
      },
      // {
      //   path: `${staffRoute.base}${staffRoute.inventory}${staffRoute.estimateTemplate}`,
      //   component: EstimateTemplatePageTemplate,
      //   name: MenuNameEnum.ESTIMATE_TEMPLATE,
      // },
    ],
  },
  // {
  //   path: `${staffRoute.base}${staffRoute.inventory}${staffRoute.estimateTemplate}${staffRoute.commonCreate}`,
  //   component: FormTemplateEstimateTemplate,
  // },
  // {
  //   path: `${staffRoute.base}${staffRoute.inventory}${staffRoute.estimateTemplate}${staffRoute.commonDetail}${staffRoute.commonEdit}`,
  //   component: FormTemplateEstimateTemplate,
  // },
  {
    path: `${staffRoute.base}${staffRoute.inventory}${staffRoute.materials}${staffRoute.commonDetail}`,
    component: MaterialDetailTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.inventory}${staffRoute.services}${staffRoute.commonCreate}`,
    component: FormServiceTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.inventory}${staffRoute.services}${staffRoute.commonDetail}${staffRoute.commonEdit}`,
    component: FormServiceTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.inventory}${staffRoute.services}${staffRoute.commonDetail}`,
    name: MenuNameEnum.SERVICE_DETAIL,
    component: ServiceDetailTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.inventory}${staffRoute.materials}${staffRoute.commonCreate}`,
    component: FormMaterialTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.inventory}${staffRoute.materials}${staffRoute.commonDetail}${staffRoute.commonEdit}`,
    component: FormMaterialTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.jobs}`,
    component: JobPageStaff,
    name: MenuNameEnum.JOBS,
    icon: icons.menuIconJobsInactive,
    activeIcon: icons.menuIconJobsActive,
  },
  {
    path: `${staffRoute.base}${staffRoute.jobs}${staffRoute.commonCreate}`,
    component: FormJobTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.jobs}${staffRoute.commonDetail}`,
    name: MenuNameEnum.JOBS_DETAIL,
    component: JobDetailTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.jobs}${staffRoute.commonDetail}${staffRoute.commonEdit}`,
    component: FormJobTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.tasks}`,
    component: TaskPageStaff,
    name: MenuNameEnum.TASKS,
    icon: icons.menuIconTasksInactive,
    activeIcon: icons.menuIconTasksActive,
  },
  {
    path: `${staffRoute.base}${staffRoute.tasks}${staffRoute.commonCreate}`,
    component: FormTaskTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.tasks}${staffRoute.commonDetail}${staffRoute.commonEdit}`,
    component: FormTaskTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.tasks}${staffRoute.commonDetail}`,
    component: TaskDetailPageTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.estimate}`,
    component: EstimatePageTemplate,
    name: MenuNameEnum.ESTIMATE,
    icon: icons.menuIconEstimateInactive,
    activeIcon: icons.menuIconEstimateActive,
  },
  {
    path: `${staffRoute.base}${staffRoute.estimate}${staffRoute.commonCreate}`,
    component: FormEstimateTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.estimate}${staffRoute.commonDetail}${staffRoute.commonEdit}`,
    component: FormEstimateTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.estimate}${staffRoute.commonDetail}`,
    component: EstimateDetailTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.invoice}`,
    component: InvoicePageStaff,
    name: MenuNameEnum.INVOICE,
    icon: icons.menuIconInvoiceInactive,
    activeIcon: icons.menuIconInvoiceActive,
  },
  {
    path: `${staffRoute.base}${staffRoute.invoice}${staffRoute.commonDetail}`,
    component: InvoiceDetailTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.timeClock}`,
    component: TimeClockPageTemplate,
    name: MenuNameEnum.TIME_CLOCK,
    icon: icons.menuIconTimeClockInactive,
    activeIcon: icons.menuIconTimeClockActive,
  },
  {
    path: `${staffRoute.base}${staffRoute.timeClock}${staffRoute.commonDetail}`,
    component: TimeClockDetailTemplate,
  },
  // {
  //   path: `${staffRoute.base}${staffRoute.payroll}`,
  //   component: PayrollPageStaff,
  //   name: MenuNameEnum.PAYROLL,
  //   icon: icons.menuIconPayrollInactive,
  //   activeIcon: icons.menuIconPayrollActive,
  // },
  {
    path: `${staffRoute.base}${staffRoute.marketing}`,
    component: MarketingPageTemplate,
    name: MenuNameEnum.MARKETING,
    icon: icons.menuIconMarketingInactive,
    activeIcon: icons.menuIconMarketingActive,
    children: [
      {
        path: `${staffRoute.base}${staffRoute.marketing}${staffRoute.campaigns}`,
        component: CampaignPageTemplate,
        name: MenuNameEnum.CAMPAIGNS,
      },
    ],
  },
  {
    path: `${staffRoute.base}${staffRoute.marketing}${staffRoute.campaigns}${staffRoute.commonCreate}`,
    component: FormCampaignTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.marketing}${staffRoute.campaigns}${staffRoute.commonDetail}${staffRoute.commonEdit}`,
    component: FormCampaignTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.marketing}${staffRoute.campaigns}${staffRoute.commonDetail}`,
    component: CampaignDetailTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.review}`,
    component: SubReviewPageTemplate,
    name: MenuNameEnum.REVIEW,
    icon: icons.MenuIconReviewInactive,
    activeIcon: icons.MenuIconReviewActive,
    // children: [
    //   {
    //     path: `${staffRoute.base}${staffRoute.review}`,
    //     component: SubReviewPageTemplate,
    //     name: MenuNameEnum.REVIEW,
    //   },
    // ],
  },
  {
    path: `${staffRoute.base}${staffRoute.reports}`,
    component: ReportPageTemplate,
    name: MenuNameEnum.REPORTS,
    icon: icons.menuIconReportsInactive,
    activeIcon: icons.menuIconReportsActive,
  },
  {
    path: `${staffRoute.base}${staffRoute.reports}${staffRoute.technicianReport}`,
    component: ReportTechnicianPageTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.reports}${staffRoute.saleByCityReport}`,
    component: ReportSaleByCityPageTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.reports}${staffRoute.serviceVolumeReport}`,
    component: ReportServiceVolumePageTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.reports}${staffRoute.perCallAverageReport}`,
    component: ReportPerCallAveragePageTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.reports}${staffRoute.poPerPayPeriodReport}`,
    component: ReportPoPerPayPeriodPageTemplate,
  },
  // {
  //   path: `${staffRoute.base}${staffRoute.settings}`,
  //   component: SettingsPageStaff,
  //   name: MenuNameEnum.SETTINGS,
  //   icon: icons.menuIconSettingsInactive,
  //   activeIcon: icons.menuIconSettingsActive,
  //   children: [
  //     {
  //       path: `${staffRoute.base}${staffRoute.settings}${staffRoute.integration}`,
  //       component: IntegrationPageStaff,
  //       name: MenuNameEnum.INTEGRATION,
  //     },
  //     // {
  //     //   path: `${staffRoute.base}${staffRoute.settings}${staffRoute.priceBooks}`,
  //     //   component: PriceBookTemplate,
  //     //   name: MenuNameEnum.PRICE_BOOKS,
  //     // },
  //   ],
  // },
  {
    path: `${staffRoute.base}${staffRoute.settings}${staffRoute.priceBooks}${staffRoute.commonCreate}`,
    component: FormPriceBookTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.settings}${staffRoute.priceBooks}${staffRoute.commonDetail}${staffRoute.commonEdit}`,
    component: FormPriceBookTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.settings}${staffRoute.priceBooks}${staffRoute.commonDetail}`,
    component: PriceBookDetailTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.message}`,
    component: MessagePageTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.profile}`,
    component: ProfileTemplate,
  },
  {
    path: `${staffRoute.base}${staffRoute.gmail}`,
    component: GmailPageTemplate,
  },
];

export const staffRouteAbsolute = {
  dashboard: `${staffRoute.base}`,
  customers: `${staffRoute.base}${staffRoute.customers}`,
  schedules: `${staffRoute.base}${staffRoute.schedule}`,
  contacts: `${staffRoute.base}${staffRoute.crm}${staffRoute.contacts}`,
  employees: `${staffRoute.base}${staffRoute.employees}`,
  createEmployee: `${staffRoute.base}${staffRoute.employees}${staffRoute.commonCreate}`,
  updateEmployee: (employeeId: string) =>
    `${staffRoute.base}${staffRoute.employees}/${employeeId}${staffRoute.commonEdit}`,
  createCustomer: `${staffRoute.base}${staffRoute.customers}${staffRoute.commonCreate}`,
  editCustomer: (customerId: string) =>
    `${staffRoute.base}${staffRoute.customers}/${customerId}${staffRoute.commonEdit}`,
  jobs: `${staffRoute.base}${staffRoute.jobs}`,
  createJob: `${staffRoute.base}${staffRoute.jobs}${staffRoute.commonCreate}`,
  createContact: `${staffRoute.base}${staffRoute.crm}${staffRoute.contacts}${staffRoute.commonCreate}`,
  updateContact: (contactId: string) =>
    `${staffRoute.base}${staffRoute.crm}${staffRoute.contacts}/${contactId}${staffRoute.commonEdit}`,
  updateJob: (jobId: string) => `${staffRoute.base}${staffRoute.jobs}/${jobId}${staffRoute.commonEdit}`,
  tasks: `${staffRoute.base}${staffRoute.tasks}`,
  updateTask: (taskId: string) => `${staffRoute.base}${staffRoute.tasks}/${taskId}${staffRoute.commonEdit}`,
  createTask: `${staffRoute.base}${staffRoute.tasks}${staffRoute.commonCreate}`,
  service: `${staffRoute.base}${staffRoute.inventory}${staffRoute.services}`,
  createService: `${staffRoute.base}${staffRoute.inventory}${staffRoute.services}${staffRoute.commonCreate}`,
  updateService: (serviceId: string) =>
    `${staffRoute.base}${staffRoute.inventory}${staffRoute.services}/${serviceId}${staffRoute.commonEdit}`,
  materials: `${staffRoute.base}${staffRoute.inventory}${staffRoute.materials}`,
  createMaterials: `${staffRoute.base}${staffRoute.inventory}${staffRoute.materials}${staffRoute.commonCreate}`,
  updateMaterial: (materialId: string) =>
    `${staffRoute.base}${staffRoute.inventory}${staffRoute.materials}/${materialId}${staffRoute.commonEdit}`,
  priceBooks: `${staffRoute.base}${staffRoute.settings}${staffRoute.priceBooks}`,
  createPriceBook: `${staffRoute.base}${staffRoute.settings}${staffRoute.priceBooks}${staffRoute.commonCreate}`,
  updatePriceBook: (priceBookId: string) =>
    `${staffRoute.base}${staffRoute.settings}${staffRoute.priceBooks}/${priceBookId}${staffRoute.commonEdit}`,
  message: `${staffRoute.base}${staffRoute.message}`,
  timeClock: `${staffRoute.base}${staffRoute.timeClock}`,
  estimate: `${staffRoute.base}${staffRoute.estimate}`,
  createEstimate: `${staffRoute.base}${staffRoute.estimate}${staffRoute.commonCreate}`,
  createEstimateTemplate: `${staffRoute.base}${staffRoute.inventory}${staffRoute.estimateTemplate}${staffRoute.commonCreate}`,
  updateEstimateTemplate: (templateId: string) =>
    `${staffRoute.base}${staffRoute.inventory}${staffRoute.estimateTemplate}/${templateId}${staffRoute.commonEdit}`,
  createCampaign: `${staffRoute.base}${staffRoute.marketing}${staffRoute.campaigns}${staffRoute.commonCreate}`,
  updateCampaign: (campaignId: string) =>
    `${staffRoute.base}${staffRoute.marketing}${staffRoute.campaigns}/${campaignId}${staffRoute.commonEdit}`,
  updateEstimate: (estimateId: string) =>
    `${staffRoute.base}${staffRoute.estimate}/${estimateId}${staffRoute.commonEdit}`,
  profile: `${staffRoute.base}${staffRoute.profile}`,
  invoice: `${staffRoute.base}${staffRoute.invoice}`,
  gmail: `${staffRoute.base}${staffRoute.gmail}`,
  technicianReport: `${staffRoute.base}${staffRoute.reports}${staffRoute.technicianReport}`,
  saleByCityReport: `${staffRoute.base}${staffRoute.reports}${staffRoute.saleByCityReport}`,
  serviceVolumeReport: `${staffRoute.base}${staffRoute.reports}${staffRoute.serviceVolumeReport}`,
  perCallAverageReport: `${staffRoute.base}${staffRoute.reports}${staffRoute.perCallAverageReport}`,
  poPerPayPeriodReport: `${staffRoute.base}${staffRoute.reports}${staffRoute.poPerPayPeriodReport}`,
};
